import React, { Component } from 'react';
import { Wrapper, Tile, Row } from './components';
import { Responsive } from '../index';

function getChildren(items, mobile) {
	return (
		<Wrapper>
			{items.map((item, index) => {
				const rowKey = `${Math.random()}-index`;
				return (
					<Row key={rowKey}>
						{item.map((tile, index) => {
							const colKey = `${rowKey}-${index}`;
							return (
								
								<Tile
									key={colKey}
									title={tile.title}
									background={tile.thumbnail}
									onClick={() => window.location = tile.link}
									mobile={mobile}
								>
									<span>
										{tile.title}
									</span>
								</Tile>
							);
						})}
					</Row>
				);
			})}
		</Wrapper>
	);
}
class Portfolio extends Component {
	render() {
		return (
			<span>
				<Responsive.Desktop>
					{getChildren(this.props.items, false)}
				</Responsive.Desktop>
				<Responsive.Mobile>
					{getChildren(this.props.items, true)}
				</Responsive.Mobile>
			</span>
		);
		
	}
}

export default Portfolio;


// WEBPACK FOOTER //
// ./src/components/portfolio/index.js